module.exports = __webpack_public_path__ + "static/img/ai-img.74a56314.png";